<template>
	<div v-if="showRegionSwitcher" class="region-switcher-container">
		<div class="region-prompt">
			{{ $t('navigation.region-switcher.prompt', regionSwitcherData.lang) }}
		</div>
		<div class="region-actions">
			<!-- eslint-disable vue/no-v-html -->
			<button
				class="btn-region primary"
				@click="handleSwitchRegion"
				v-html="$t('navigation.region-switcher.continue', regionSwitcherData.lang, [regionSwitcherBoldRegionName])"
			></button>
			<!-- eslint-enable vue/no-v-html -->
			<button class="btn-region" @click="handleDismissRegionSwitcher('Stay Button')">
				{{ $t('navigation.region-switcher.dismiss', regionSwitcherData.lang) }}
			</button>
			<div class="close-x-container" @click="handleDismissRegionSwitcher('Close Button')">
				<svgIcon class="close-x close-x-default" icon-holder-class="icon-close thick-x-default" icon-id="icon-thick-x-default" />
				<svgIcon class="close-x close-x-hover" icon-holder-class="icon-close thick-x-hover" icon-id="icon-thick-x-hover" />
				<svgIcon class="close-x close-x-press" icon-holder-class="icon-close thick-x-press" icon-id="icon-thick-x-press" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
export default {
	name: 'RegionSwitcher',
	components: {
		svgIcon,
	},
	computed: {
		regionSwitcherBoldRegionName() {
			return `&nbsp;<b>${this.$t(`navigation.region.${this.regionSwitcherData.regionName}`, this.regionSwitcherData.lang)}</b>&nbsp;`;
		},
		...mapGetters('regionSwitcher', ['showRegionSwitcher', 'regionSwitcherData']),
		...mapState(['isLoggedIn']),
	},
	watch: {
		showRegionSwitcher(val) {
			if (val) {
				document.body.classList.add('region-switcher-body');
				window.dataLayer.push({
					event: 'Viewed Region Switcher',
					'RS - Detected Region': this.regionSwitcherData.regionName,
				});
			}
		},
	},
	methods: {
		handleSwitchRegion() {
			// When user selects to follow link:
			// Because redirect happens inside GTM action, first make a settimeout
			// that will complete the redirect after 2 seconds if the action totally fails.
			const timeoutHandle = window.setTimeout(() => {
				window.location = this.regionSwitcherData.regionalURL;
			}, 2000);
			window.dataLayer.push({
				event: 'Switched Region with Switcher',
				eventCallback: () => {
					// Clear the other timeout because redirecting twice would be weird
					window.clearTimeout(timeoutHandle);
					// do the redirect here if tracking fires properly
					window.location = this.regionSwitcherData.regionalURL;
				},
				'RS - Detected Region': this.regionSwitcherData.regionName,
			});
		},
		handleDismissRegionSwitcher(closeMethod) {
			// closeMethod should be 'Stay Button' or 'Close Button'
			window.dataLayer.push({
				event: 'Closed Region Switcher',
				'RS - Detected Region': this.regionSwitcherData.regionName,
				'RS - Close Method': closeMethod,
			});
			document.body.classList.remove('region-switcher-body');
			this.$store.dispatch('regionSwitcher/setDismiss');
		},
	},
};
</script>

<style lang="less" scoped>
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
.region-switcher-container {
	z-index: 100;
	position: relative;
	background-color: #242424;
	color: rgba(255, 255, 255, 0.6);
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 26px 20px;
	.region-actions {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
	}
	.region-prompt {
		text-align: center;
		line-height: 1.43;
		margin-bottom: 16px;
	}
	.close-x-container {
		.close-x {
			height: 12px;
			width: 12px;
			position: absolute;
			right: 20px;
			top: 8px;

			@media (min-width: 1025px) {
				top: 30px;
			}
		}
		.close-x-default {
			display: block;
		}
		.close-x-hover {
			display: none;
		}
		.close-x-press {
			display: none;
		}
		&:hover {
			cursor: pointer;
			.close-x-default {
				display: none;
			}
			.close-x-hover {
				display: block;
			}
			.close-x-press {
				display: none;
			}
		}
		&:active {
			.close-x-default {
				display: none;
			}
			.close-x-hover {
				display: none;
			}
			.close-x-press {
				display: block;
			}
		}
	}

	.btn-region {
		width: 281px;
		height: 47px;
		margin: 4px;
		font-family: Arial;
		font-size: 12px;
		// font-weight: bold;
		text-transform: uppercase;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 3px;
		background-color: #4c4c4c;
		border-color: transparent;
		color: #fefefe;
		transition: all 0.2s ease;
		&:focus {
			outline: none;
		}
		&:hover {
			cursor: pointer;
			background-color: #808080;
		}
		&:active {
			background-color: #383838;
			color: #999999;
		}
		&.primary {
			color: #ffffff;
			background-color: #0077ff;
			&:hover {
				background-color: #3093ff;
			}
			&:active {
				opacity: 0.5;
			}
		}
	}
}
</style>
